/**
 * docs.json names a page's icon by its lucide name. A fixed map rather than
 * lucide's full `icons` export, which would pull every icon into the bundle;
 * an unknown name falls back to a plain page.
 */
import {
  Rocket,
  LayoutPanelLeft,
  Keyboard,
  Send,
  Braces,
  FlaskConical,
  Folder,
  Download,
  Radio,
  Database,
  SquareTerminal,
  Terminal,
  Server,
  Mail,
  SquareKanban,
  Kanban,
  FileText,
  Calendar,
  MessageSquare,
  FolderKanban,
  Network,
  Lock,
  Bot,
  BadgeCheck,
  LifeBuoy,
  History,
  BookOpen,
  Settings,
  Users,
  Plug,
} from 'lucide-react';

const DOC_ICONS = {
  rocket: Rocket,
  'layout-panel-left': LayoutPanelLeft,
  keyboard: Keyboard,
  send: Send,
  braces: Braces,
  'flask-conical': FlaskConical,
  folder: Folder,
  download: Download,
  radio: Radio,
  database: Database,
  'square-terminal': SquareTerminal,
  terminal: Terminal,
  server: Server,
  mail: Mail,
  'square-kanban': SquareKanban,
  kanban: Kanban,
  'file-text': FileText,
  calendar: Calendar,
  'message-square': MessageSquare,
  'folder-kanban': FolderKanban,
  network: Network,
  lock: Lock,
  bot: Bot,
  'badge-check': BadgeCheck,
  'life-buoy': LifeBuoy,
  history: History,
  'book-open': BookOpen,
  settings: Settings,
  users: Users,
  plug: Plug,
};

export function docIcon(name) {
  return DOC_ICONS[name] || FileText;
}
